<div class="row">
  <div class="col-xs-12 col-lg-6">
    <p>{{ "Cert.CBW.Paragraph1" | translate }}</p>
    <p>{{ "Cert.CBW.Paragraph2" | translate }}</p>
  </div>
  <div class="col-xs-12 col-lg-5 offset-lg-1 cbw-buttons">
    <p>{{ "Cert.CBW.Explanation" | translate: { email: email() } }}</p>
    @for (asset of assets(); track asset.name) {
      <safe-button
        (clicked)="collect(asset.name)"
        [small]="true"
        [loading]="collectingAsset() === asset.name"
        [disabled]="isLoading()"
        >{{ asset.labelKey | translate }}</safe-button
      >
    }
  </div>
</div>
